<template>
  <g>
    <path
      d="M12.0032 23.1246C18.1211 23.1246 23.0807 18.1651 23.0807 12.0472C23.0807 5.92927 18.1211 0.969727 12.0032 0.969727C5.88533 0.969727 0.925781 5.92927 0.925781 12.0472C0.925781 18.1651 5.88533 23.1246 12.0032 23.1246Z"
      :fill="bgColor"
    />
    <path
      d="M12 24.0439C5.38305 24.0439 0 18.6609 0 12.0439C0 5.42699 5.38305 0.0439453 12 0.0439453C18.617 0.0439453 24 5.42699 24 12.0439C24 18.6609 18.617 24.0439 12 24.0439ZM12 1.88903C6.40015 1.88903 1.84509 6.4441 1.84509 12.0439C1.84509 17.6438 6.40015 22.1989 12 22.1989C17.5998 22.1989 22.1549 17.6438 22.1549 12.0439C22.1549 6.4441 17.5998 1.88903 12 1.88903Z"
      :fill="borderColor"
    />
    <path
      d="M16.2358 4.07227C18.3392 5.19316 19.9468 7.12358 20.641 9.44609L16.2358 4.07227Z"
      :fill="bgColor"
    />
    <path
      d="M20.6398 9.90709C20.4415 9.90709 20.257 9.77794 20.197 9.57728C19.5466 7.407 18.0244 5.54807 16.0179 4.47792C15.7942 4.35799 15.7088 4.07892 15.8288 3.85289C15.9487 3.62918 16.2278 3.54153 16.4538 3.66377C18.6771 4.84694 20.3654 6.90652 21.085 9.31205C21.1588 9.55653 21.0204 9.81253 20.7759 9.88634C20.7275 9.90017 20.6837 9.90709 20.6398 9.90709Z"
      :fill="iconColor"
    />
    <path
      d="M9.1406 20.5797C6.69586 19.761 4.717 17.9228 3.71143 15.5703L9.1406 20.5797Z"
      :fill="bgColor"
    />
    <path
      d="M9.13871 21.0428C9.09027 21.0428 9.04184 21.0359 8.9911 21.0197C6.42642 20.1618 4.34609 18.2429 3.28285 15.7543C3.18368 15.5191 3.29208 15.2492 3.52502 15.15C3.76027 15.0509 4.03011 15.1593 4.12929 15.3922C5.08873 17.6386 6.96842 19.373 9.2817 20.1456C9.52387 20.2263 9.65302 20.487 9.5723 20.7291C9.51234 20.9206 9.33244 21.0428 9.13871 21.0428Z"
      :fill="iconColor"
    />
    <path
      d="M8.44092 7.50293H12.5924C15.0417 7.50293 16.6193 8.7622 16.6193 10.9071V10.9348C16.6193 13.2181 14.8618 14.422 12.454 14.422H11.1255V17.1896H8.44092V7.50293ZM12.3986 12.3186C13.3535 12.3186 13.9347 11.8204 13.9347 11.0593V11.0317C13.9347 10.2014 13.3535 9.75855 12.3848 9.75855H11.1255V12.3186H12.3986Z"
      :fill="iconColor"
    />
  </g>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props:{
    bgColor: { type: String, default: "#ffffff" },
    iconColor: { type: String, default: "#ee1c25" },
    borderColor: { type: String, default: "#ee1c25" }
  }
})
export default class IconPointDefaultPath extends Vue {
  bgColor!: string;
  iconColor!: string;
  borderColor!: string;
}
</script>
